import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = '查看更多' }: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1.5 rounded-full bg-gradient-to-b from-primary-400 to-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}